import { z } from 'zod';
import { Command } from './commands.js';
import { Id } from './common.js';
import { Device } from './devices.js';

/** Messages the server pushes to the dashboard over /api/v1/ws. */
export const WsEvent = z.discriminatedUnion('type', [
  z.object({ type: z.literal('device.updated'), device: Device }),
  z.object({ type: z.literal('device.removed'), deviceId: Id }),
  z.object({ type: z.literal('command.updated'), command: Command }),
]);
export type WsEvent = z.infer<typeof WsEvent>;

/** Close code sent when the session behind a socket ends (logout or expiry). */
export const WS_CLOSE_SESSION_ENDED = 4001;

/** Close code when a user or device already has as many live connections as allowed. */
export const WS_CLOSE_TOO_MANY = 4008;
